import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'schoolYear',
	standalone: true,
})
export class SchoolYearPipe implements PipeTransform {
    transform(value?: string | null): string {
        if (!value) {
            return '';
        }

        return value.length === 4 ? `20${value.slice(0, 2)} - 20${value.slice(2)}` : `${value.slice(0, 4)} - ${value.slice(4)}`;
    }
}
